import React from "react";
import moment from "moment";
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";


const DeploymentCreditsTable = ({ tableData, searchQuery, defaultSorted }) => {
  const { ExportCSVButton } = CSVExport;

  const creditsFormatter = (cell, row) => <b>{cell}</b>;

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format('YYYY-MM-DD')
    );
  };
  
  const receiptFormatter = cell =>
    cell ?
    (
      <a href={cell} target="blank">
      <Button className="btn-status" color="primary">
        <b>View</b>
      </Button>
      </a>
    ) : <b>Not Available</b>;

  const kindFormatter = cell => {
    return cell === "credit" ? 
    <Button className="btn-status" color="success">
      <b className="mdi mdi-plus pr-2">Credit</b>
    </Button> : 
    <Button className="btn-status" color="danger">
      <b className="mdi mdi-minus pr-2">Debit</b>
    </Button>;
  };

  const columns = [
    {
      dataField: "quantity",
      text: "Quantity",
      sort: true,
      formatter: creditsFormatter,
    },
    {
      dataField: "description",
      text: "Description",
      sort: false,
    },
    {
      dataField: "kind",
      text: "Type",
      sort: true,
      formatter: kindFormatter,
    },
    {
      dataField: "balance",
      text: "Balance",
      sort: true,
      formatter: creditsFormatter,
    },
    {
      dataField: "created",
      text: "Date",
      sort: true,
      formatter: dateFormatter,
      csvFormatter: dateFormatter,
    },
    {
      dataField: "stripe_receipt_url",
      text: "Receipt",
      sort: false,
      formatter: receiptFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
  ];

  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "quantity" || sortField === "kind" || sortField === "kind" || sortField === "balance" || sortField === "created") {
      searchQuery.setOrdering({order: ascDesc, name: sortField, sort: sortField});
    }
  }

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={ {
        fileName: 'deployment-credits.csv',
      } }
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input placeholder="Search..." value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)}/>
              </div>
            </Col>
            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton
                  className="btn btn-outline-info"
                  {...props.csvProps}
                >
                  Export CSV
                </ExportCSVButton>
                <Link to="/deployment-credits/order" className="ml-2 btn btn-outline-success">Order Credits</Link>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={ false }
            remote={ { sort: true } }
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default DeploymentCreditsTable;
